

import PropTypes from 'prop-types';
import React, { Component } from 'react';
import styles from './ToggleText.css';
import withStyles from '../../decorators/withStyles';


class ToggleText extends Component {

  static propTypes = {

  };

  render() {
    return (
      <span className="ToggleText">
        {this.props.children}
      </span>
    );
  };

}

export default withStyles(styles)(ToggleText);
